import { Options, useMediaQuery, useTheme } from '@mui/material';

export const useIsMobile = (options?: Options) =>
  useMediaQuery(useTheme().breakpoints.down('sm'), options);
